import React, { useEffect, useState } from "react";
import PageHeader from "../PageHeader";
// import { ReactComponent as ExamIcon } from "../../../images/examimage/examicon.svg";
// import { ReactComponent as AddIcon } from "../../../images/pageheadingicon/addicon.svg";
import useStyles from "../styles";
import ViewExam from "./ViewExam";
import IdentityVerificationModal from "./IdentityVerificationModal";
// import { fetchRegistrationUploadApi } from "../../../services/service";
import { useNavigate } from "react-router-dom";

function Exam() {
  const classes = useStyles();
  const navigate = useNavigate();

  const [openVerification, setOpenVerification] = useState(false);

  // const fetchRegistrationUploadData = async () => {
  //   try {
  //     const candidateData = await fetchRegistrationUploadApi();
  //     const photo = candidateData?.register_photo;
  //     const idProof = candidateData?.register_id_proof;
  //     const status = candidateData?.status;
  //     // Open popup only if one or both are missing
  //     if (status === "approved") {
  //       setOpenVerification(false);
  //     } else {
  //       setOpenVerification(true);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching data: ", error);
  //   }
  // };

  // useEffect(() => {
  //   fetchRegistrationUploadData();
  // }, []);

  const handleVerify = () => {
    setOpenVerification(false);
    navigate("/faceregistration");
  };

  const Heading = [
    { 
      id: 1,
      mainheading: "My Exam",
    },
  ];
  return (
    <div className={` ${classes.pb0} ${classes.pt1}`}>
      {/* <PageHeader Heading={Heading} /> */}
      <ViewExam />
      {/* <IdentityVerificationModal
        open={openVerification}
        onClose={() => setOpenVerification(false)}
        onVerify={handleVerify}
      /> */}
    </div>
  );
}
export default Exam;
